import { Component, Input, OnInit,ViewContainerRef } from '@angular/core';
import { FormBuilder,  FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router , Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Errors, UserService } from '../shared';

@Component({
  selector: 'reset-password',
  templateUrl: './changepassword.component.html'
})
export class ChangePasswordComponent implements OnInit {
  authType: String = '';
  title: String = '';
  errors: Errors = new Errors();
  isSubmitting = false;
  authForm: FormGroup;
  token;
  email;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    public toastr: ToastsManager, vcr: ViewContainerRef,
  ) {
    // use FormBuilder to create a form group
     this.toastr.setRootViewContainerRef(vcr);
    this.authForm = this.fb.group({
      'password': ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]],
      'confirmPassword': ['', Validators.required],
    },{validator: this.checkIfMatchingPasswords('password', 'confirmPassword')});
  }
  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
          return (group: FormGroup) => {
            let passwordInput = group.controls[passwordKey],
                passwordConfirmationInput = group.controls[passwordConfirmationKey];
            if (passwordInput.value !== passwordConfirmationInput.value) {
              return passwordConfirmationInput.setErrors({notEquivalent: true})
            }
            else {
                return passwordConfirmationInput.setErrors(null);
            }
          }
        }
  ngOnInit() {
   this.route.queryParams.subscribe(params => {
        console.log(params)
        this.email = params["Email"];
        this.token = params["Code"];
    });
    
  }

  
  submit() {
    this.isSubmitting = true;
    let data ={
       Email:  this.email,
       password:  this.authForm.value.password,
       ConfirmPassword:  this.authForm.value.confirmPassword,
       Code:  this.token
    }
    
	console.log(data);
    this.userService
    .changePassword(data)
    .subscribe(
      data => {
         
         this.toastr.success("Your password has been reset successfully");
          var router = this.router;
        setTimeout(() => {
          router.navigateByUrl('/login');
        }, 3000);
      },
      err => {
        //this.errors = err;
         this.toastr.error(err);
      }
    );
  }    
}



// WEBPACK FOOTER //
// ./src/app/auth/changepassword.component.ts